import { Autocomplete as MuiAutocomplete, TextField as MuiTextField, styled } from "@mui/material"

import { isBaseColor } from "../../utils/isBaseColor"

export const TextField = styled(MuiTextField)(({ theme }) => ({
    "& > .MuiOutlinedInput-root": {
        borderRadius: theme.spacing(3),
    },
}))

type ChipsContainerProps = {
    maxHeight: string | number
}

export const ChipsContainer = styled("div", { shouldForwardProp: (prop) => prop !== "maxHeight" })<ChipsContainerProps>(({ maxHeight }) => ({
    maxHeight: maxHeight,
    overflowY: "auto",

    "& > .MuiAutocomplete-tag": {
        maxWidth: "100%",
    },
}))

type AutoCompleteProps = {
    color: "primary" | "secondary" | "tertiary" | "action/darkRed"
}

export const AutoComplete = styled(MuiAutocomplete, { shouldForwardProp: (prop) => prop !== "maxHeight" })<AutoCompleteProps>(({ color, theme }) => {
    return ({
        "& .MuiAutocomplete-tagSizeMedium": {
            backgroundColor: `${theme.palette.common.white}`,
            color: `${theme.palette?.[color]?.main}`,
        },
        "& .MuiChip-filled ": {
            backgroundColor: `${theme.palette?.[color]?.main} !important`,
            color: `${theme.palette.common.white} !important`,
        },
        ...!isBaseColor(color) && {
            "& .MuiAutocomplete-tag.MuiChip-filled .MuiChip-deleteIcon": {
                color: `${theme.palette.common.white} !important`,
                opacity: 0.7,

                "&:hover": {
                    color: `${theme.palette.common.white}`,
                    opacity: 1,
                },
            },
            "& .MuiAutocomplete-tag.MuiChip-outlined .MuiChip-deleteIcon": {
                color: `${theme.palette?.[color]?.main} !important`,
                opacity: 0.7,

                "&:hover": {
                    color: `${theme.palette?.[color]?.main}`,
                    opacity: 1,
                },
            }
        }
    })
})